<!-- nav -->
<ng-container *ngIf="userConnected | async">
  <!--  header -->
  <nav app-header *ngIf="!isMobileApp"></nav>

  <main id="main" [class]="isMobileApp ? 'mobile-app' : ''">
    <mat-sidenav-container
      [class.mt-0]="isMobileApp"
      (backdropClick)="onBackDropClick()"
    >
      <mat-sidenav
        id="main-side-nav"
        #snav
        [mode]="navMode"
        [fixedInViewport]="navFixedInViewport"
        fixedTopGap="56"
        [(opened)]="opened"
      >
        <app-main-menu *ngIf="!isNavigationDisabled()"></app-main-menu>
      </mat-sidenav>

      <mat-sidenav-content #snavcontent>
        <app-assumed-user-disconnect></app-assumed-user-disconnect>
        <div>
          <ng-container *ngTemplateOutlet="mainContent"></ng-container>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </main>
  <app-help-scout-widget></app-help-scout-widget>
  <div id="swiper-overlay-container"></div>
</ng-container>

<!-- public app container -->
<div *ngIf="!(userConnected | async)" id="login-wrap">
  <div class="bkg">&nbsp;</div>
  <div class="wrap-split">
    <!-- left -->
    <div class="split-part login-left">
      <img src="assets/images/logo_eemo_white.svg" width="140" />
      <p>L'<i>eemobilier</i> en toute simplicité</p>
    </div>
    <!-- right -->
    <div class="split-part login-right">
      <ng-container *ngTemplateOutlet="publicContent"></ng-container>
    </div>
  </div>
</div>

<div class="env" *ngIf="appConfigService.isDev() || appConfigService.isDemo()">
  <span *ngIf="appConfigService.isDev()" class="text-warning">Dev</span>
  <span *ngIf="appConfigService.isDemo()" class="text-warning">Démo</span>
</div>

<ng-template #publicContent>
  <app-alert></app-alert>
  <router-outlet (activate)="onActivate($event)"> </router-outlet>
</ng-template>

<ng-template #mainContent>
  <app-alert></app-alert>
  <app-subscription-alert></app-subscription-alert>
  <app-float-menu></app-float-menu>
  <router-outlet (activate)="onActivate($event)"> </router-outlet>
</ng-template>
